"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PromoBoxes;
var _react = _interopRequireDefault(require("react"));
var _postmanCollection = _interopRequireDefault(require("./postmanCollection"));
var _relatedGuidesPromoBox = _interopRequireDefault(require("./relatedGuidesPromoBox"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function PromoBoxes(_ref) {
  var projectIdEncrypted = _ref.projectIdEncrypted,
    projectName = _ref.projectName,
    sor = _ref.sor,
    caseId = _ref.caseId,
    filteredApis = _ref.filteredApis,
    history = _ref.history,
    host = _ref.host,
    projectApp = _ref.projectApp,
    productName = _ref.productName,
    disabled = _ref.disabled;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-row flex h-auto mb-4 height-promo-boxes",
    "aria-disabled": disabled
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-wrap contents"
  }, /*#__PURE__*/_react.default.createElement(_postmanCollection.default, {
    projectIdEncrypted: projectIdEncrypted,
    projectName: projectName,
    caseId: caseId,
    sor: sor,
    filteredApis: filteredApis,
    host: host,
    projectApp: projectApp,
    productName: productName,
    disabled: disabled
  }), /*#__PURE__*/_react.default.createElement(_relatedGuidesPromoBox.default, {
    projectIdEncrypted: projectIdEncrypted,
    projectName: projectName,
    caseId: caseId,
    sor: sor,
    filteredApis: filteredApis,
    history: history,
    projectApp: projectApp,
    disabled: disabled
  }))));
}